'use es6';

import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';

const fetchPublicMetaData = countryOverride => {
  // This logic and code should be kept consistent with publicEarlyRequester.js
  const navigator = window.navigator;
  let preferredLanguage = navigator.languages || navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
  let publicMetaUrl = '/monetization/v3/public-pricing';

  if (preferredLanguage && preferredLanguage.length) {
    if (Array.isArray(preferredLanguage)) {
      // This is simpler than the existing dot com logic
      // but I think this is sufficient since the fallbacks
      // aren't very important
      // See: https://codepen.io/anythingcodes/pen/XwdzYW?editors=0010
      preferredLanguage = preferredLanguage[0];
    }

    publicMetaUrl = `${publicMetaUrl}/${preferredLanguage.toLowerCase()}`;
  }

  const isInIndia = window.location.host.indexOf('hubspot.in') > -1;
  const preferredCountryFromDomain = isInIndia ? 'in' : window.COUNTRY_CODE_FROM_LOCALE;
  const preferredCountry = countryOverride || preferredCountryFromDomain;

  if (preferredCountry) {
    publicMetaUrl = `${publicMetaUrl}?preferredCountry=${preferredCountry}`;
  }

  publicMetaUrl = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${publicMetaUrl}`;
  return http.get(publicMetaUrl);
}; // Quick fetched, check publicEarlyRequester.js


export const getPublicMetaData = (countryOverride = null) => {
  const earlyRequest = quickFetch.getRequestStateByName('public-meta');

  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest('public-meta');
      });
      earlyRequest.onError(() => {
        fetchPublicMetaData(countryOverride).then(resolve).catch(error => {
          reject(error);
        });
        quickFetch.removeEarlyRequest('public-meta');
      });
    });
  } else {
    return fetchPublicMetaData(countryOverride);
  }
};